import Cookies from 'js-cookie';

const scripts = [];

export default function generateScript(src, id) {
  if (scripts.includes(src)) {
    return false;
  }
  const script = document.createElement('script');
  script.src = src;
  script.id = id;
  script.charset = 'utf-8';

  const cookieConsent = Cookies.get('CookieConsent');
  if (cookieConsent) {
    const marketingConsent = cookieConsent.includes('marketing:true');
    let marketingConsentJson = {};

    try {
      marketingConsentJson = JSON.parse(cookieConsent);
    } catch (ex) { /* */ }

    if (!marketingConsent && !marketingConsentJson.marketing) {
      script.type = 'text/plain';
    }
  }
  script['data-cookieconsent'] = 'marketing';
  const element = document.body;

  scripts.push(src);
  element.appendChild(script);
  return true;
}
